var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6203 7.08002C11.8637 6.98 12.1368 6.98 12.3803 7.08002C12.503 7.12761 12.6152 7.19898 12.7103 7.29002C12.893 7.48165 12.9966 7.73525 13.0003 8.00002C12.9986 8.3326 12.8317 8.6426 12.555 8.82709C12.2783 9.01157 11.9279 9.04641 11.6203 8.92002C11.4991 8.86938 11.3875 8.79835 11.2903 8.71002C11.1031 8.5213 10.9987 8.26582 11.0003 8.00002C10.9969 7.86884 11.0243 7.7387 11.0803 7.62002C11.1309 7.49883 11.2019 7.38722 11.2903 7.29002C11.3854 7.19898 11.4975 7.12761 11.6203 7.08002ZM12.0003 11H11V12H11.0003V16H11V17H12.0003H15V16H13.0003V12L13 11.9762V11H12.0003Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSolid);
export default ForwardRef;